(() => {
  const modal = document.getElementById('QuickBuyModal');
  if (!modal) return;

  modal.classList.add('qb-modal');

  const titleEl = modal.querySelector('.qb-title');
  const variantsWrap = modal.querySelector('.qb-variants');
  const addBtn = modal.querySelector('.qb-add');

  const originalParent = modal.parentElement;
  const originalNext = modal.nextElementSibling;

  let selectedVariantId = null;

  function moveModalBack() {
    if (!originalParent) return;
    if (originalNext && originalNext.parentElement === originalParent) {
      originalParent.insertBefore(modal, originalNext);
    } else {
      originalParent.appendChild(modal);
    }
  }

  function openModalInCard(triggerEl) {
  // o modal deve "morar" dentro do container da imagem
  const media =
    triggerEl.closest('.card__media') ||
    triggerEl.closest('.card__inner') ||
    triggerEl.closest('.card');

  if (media) {
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    media.appendChild(modal);
  }

  modal.hidden = false;
}


  function closeModal() {
    modal.hidden = true;
    selectedVariantId = null;
    if (variantsWrap) variantsWrap.innerHTML = '';
    if (titleEl) titleEl.textContent = '';
    moveModalBack();
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Falha ao carregar produto');
    return await res.json();
  }

  async function addToCart(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data?.description || 'Erro ao adicionar no carrinho');
    }
    return await res.json();
  }

  // =========
  // Helpers para identificar "Tamanho"
  // =========
  const SIZE_LABELS = [
    'tamanho', 'tamanhos', 'size', 'sizes',
    'tam', 'numeração', 'numeracao', 'número', 'numero'
  ];

  function findSizeOptionIndex(product) {
    // product.options é um array com os nomes: ["Cor", "Tamanho"] etc.
    const opts = product.options || [];
    const idx = opts.findIndex(name => {
      const n = String(name || '').trim().toLowerCase();
      return SIZE_LABELS.some(k => n.includes(k));
    });
    return idx; // -1 se não achou
  }

  function getVariantSizeValue(variant, sizeOptionIndex) {
    // Shopify .js: variant.options = ["Concha", "0"] por exemplo
    if (Array.isArray(variant.options) && sizeOptionIndex >= 0) {
      const val = variant.options[sizeOptionIndex];
      if (val != null) return String(val).trim();
    }

    // fallback: tenta pegar o último item depois de "/"
    const parts = String(variant.title || '').split('/');
    return String(parts[parts.length - 1] || variant.title || '').trim();
  }

  function renderVariants(product) {
    if (!variantsWrap) return;

    variantsWrap.innerHTML = '';
    selectedVariantId = null;

    const sizeOptionIndex = findSizeOptionIndex(product);

    // remove duplicados pelo valor exibido (muito comum quando tem cor + tamanho)
    const seen = new Set();

    // pega variantes disponíveis primeiro (opcional)
    const variants = (product.variants || []).slice();

    variants.forEach((variant) => {
      const label = getVariantSizeValue(variant, sizeOptionIndex);

      // evita duplicar (ex: mesma numeração em várias cores)
      const key = label.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qb-variant';
      btn.textContent = label;

      if (!variant.available) btn.classList.add('soldout');

      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (btn.classList.contains('soldout')) return;

        variantsWrap.querySelectorAll('.qb-variant').forEach((v) => v.classList.remove('active'));
        btn.classList.add('active');

        // quando tem duplicado removido, precisamos achar o variant correto desse label
        // preferência: primeiro disponível com esse label
        const picked = variants.find(v => {
          const vLabel = getVariantSizeValue(v, sizeOptionIndex).toLowerCase();
          return vLabel === key && v.available;
        }) || variants.find(v => {
          const vLabel = getVariantSizeValue(v, sizeOptionIndex).toLowerCase();
          return vLabel === key;
        });

        selectedVariantId = picked ? picked.id : variant.id;
      });

      variantsWrap.appendChild(btn);
    });

    // auto-seleciona o primeiro disponível
    const firstAvailableBtn = Array.from(variantsWrap.querySelectorAll('.qb-variant'))
      .find(b => !b.classList.contains('soldout'));

    if (firstAvailableBtn) {
      firstAvailableBtn.click();
    }
  }

  // =========
  // Captura pointerdown pra impedir clique do card abrir produto
  // =========
  document.addEventListener(
    'pointerdown',
    (e) => {
      const trigger = e.target.closest('[data-qb-open], .qb-trigger--overlay, .qb-trigger');
      if (!trigger) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    },
    true
  );

  // =========
  // Click: abrir/fechar
  // =========
  document.addEventListener(
    'click',
    async (e) => {
      const close = e.target.closest('[data-qb-close], .qb-close, .qb-overlay');
      if (close) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        closeModal();
        return;
      }

      const trigger = e.target.closest('[data-qb-open], .qb-trigger--overlay, .qb-trigger');
      if (!trigger) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      const handle =
        trigger.getAttribute('data-product-handle') ||
        trigger.dataset.productHandle;

      if (!handle) return;

      try {
        openModalInCard(trigger);

        if (titleEl) titleEl.textContent = 'Carregando...';
        if (variantsWrap) variantsWrap.innerHTML = '';

        const product = await fetchProduct(handle);

        if (titleEl) titleEl.textContent = product.title;

        renderVariants(product);
      } catch (err) {
        console.error(err);
        if (titleEl) titleEl.textContent = 'Não foi possível abrir.';
      }
    },
    true
  );

  // =========
  // Add to cart
  // =========
  if (addBtn) {
    addBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      try {
        if (!selectedVariantId) {
          alert('Selecione uma opção');
          return;
        }

        addBtn.disabled = true;

        await addToCart(selectedVariantId);

        closeModal();

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error(err);
        alert(err.message || 'Erro ao adicionar');
      } finally {
        addBtn.disabled = false;
      }
    });
  }

  // ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
})();
